/** Shown on legal pages and Sign-up modal — keep in sync when publishing updates. */
export const LEGAL_PAGES_LAST_UPDATED = "May 1, 2026";
